exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TRouteAtAGlance-90360dc9{padding:10px 20px;background:#eee;display:flex;flex-wrap:wrap}.TRouteAtAGlance-90360dc9 .Metric-8256b81c{margin-bottom:5px;font-size:20px;line-height:22px;font-weight:500;cursor:default;white-space:nowrap;min-width:0;flex:1 1 33%}.TRouteAtAGlance-90360dc9 .Metric-8256b81c .icon-883ba671{opacity:0.5;margin-right:5px}.TRouteAtAGlance-90360dc9 .Metric-8256b81c .units-d2fb27a7{display:inline-block;font-size:13px;font-weight:400;margin-left:5px}.TRouteAtAGlance-90360dc9 .Metric-8256b81c .premiumRequired-aad7d0f5{color:#FA6400;font-size:20px;margin-left:5px}.TRouteAtAGlance-90360dc9 .pendingMetric-88186117{opacity:0.5}\n", ""]);

// Exports
exports.locals = {
	"TRouteAtAGlance": "TRouteAtAGlance-90360dc9",
	"Metric": "Metric-8256b81c",
	"icon": "icon-883ba671",
	"units": "units-d2fb27a7",
	"premiumRequired": "premiumRequired-aad7d0f5",
	"pendingMetric": "pendingMetric-88186117"
};